import clsx from "clsx";
import PropTypes from "prop-types";
import styles from "./Pebble.module.scss";

export const Pebble = ({ label, active = false, onClick }) => {
  const pebbleClasses = clsx(styles.pebble, {
    [styles.active]: active,
  });
  return (
    <button type="button" className={pebbleClasses} onClick={onClick}>
      <span>{label}</span>
    </button>
  );
};

Pebble.propTypes = {
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  active: PropTypes.bool,
};
